import { render, staticRenderFns } from "./brandMeAI.vue?vue&type=template&id=3ed4cb9c&scoped=true&"
import script from "./brandMeAI.vue?vue&type=script&lang=js&"
export * from "./brandMeAI.vue?vue&type=script&lang=js&"
import style0 from "./brandMeAI.vue?vue&type=style&index=0&id=3ed4cb9c&scoped=true&lang=scss&"
import style1 from "./brandMeAI.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4cb9c",
  null
  
)

export default component.exports